<template>
    <div style="background-color: white;box-sizing:unset;min-width:1600px">
        <headers></headers>
        <!-- 中间内容区域开始 -->
         <!-- 中文版 -->
        <div v-if="langluageType != 'en'" class="window_con">
            <div class="window_banner">
                <img src="../assets/propaganda/articledesign.jpg" class="window_banner_img">
                <div class="banner_text">
                    <img src="../assets/propaganda/design_logo.svg" class="banner_text_img">
                    <h1 style="height: 70px;">创新模式、整合资源、共享设计、合作共赢</h1>
                    <ul class="banner_ul">
                        <li><a href="#">敬&nbsp;请&nbsp;期&nbsp;待</a></li>
                    </ul>
                </div>
            </div>
            <div class="article">
                <div style="height: 120px;"></div>
                <h1>设计云的解决方案</h1>
                <div class="tit_con">
                    <p>为您提供设计资源共享的线上平台，通过平台自身聚合效益，汇集各企业存量设计资源</p>
                </div>
                <div style="height: 120px;"></div>
            </div>
        </div>
        <!-- 英文版 -->
        <div v-else class="window_con">
            <div class="window_banner">
                <img src="../assets/propaganda/articledesign1.jpg" class="window_banner_img">
                <div class="banner_text">
                    <img src="../assets/propaganda/design_logo.svg" class="banner_text_img">
                    <h1 style="height: 70px;margin-bottom: 25px;">Sharing platform for booth designer</h1>
                    <!-- <ul class="banner_ul">
                        <li><a href="#">Expect</a></li>
                    </ul> -->
                </div>
            </div>
            <div class="article" style="box-sizing:unset;width:1600px;margin-top:70px;margin-bottom: 30px;font-weight: 700;">
                <div style="height: 0px;"></div>
                <div class="tit_con" style="font-weight: 700;">
                    <p>Huge booth drawings:</p>
                    <p>covering a variety of styles and layouts, providing a variety of choices for the display space needs of different industries.</p>
                    <p>Free sharing platform:</p>
                    <p>many professional designers converge, providing rich inspiration for the creative ideas of the majority of designers.</p>
                    <p>Enterprise display space:</p>
                    <p>elaborate exclusive area, a unique stage for comprehensively displaying enterprise strength and brand image.</p>
                </div>
                <div style="height: 70px;"></div>
            </div>
        </div>
        <!-- 中间内容区域结束 -->
        <footers></footers>
        <contact></contact>
    </div>
</template>
<script>
  import headers from '@/components/Header';
  import footers from '@/components/Footer';
  import contact from '@/components/contact';

export default {
    components: {
      headers,
      footers,
      contact,
    },
    data(){
        return {
            langluageType:sessionStorage.getItem('langluageType')||'ch'
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/page/articledesign.vue